// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__kUxk9","questions":"styles_questions__3elvp","footer":"styles_footer__Ojol8"};